module.exports = __webpack_public_path__ + "static/bell-bb238eaaddc826fbc7bb8fe0aa8c2335.svg";